import classNames from 'classnames';
import type React from 'react';

export interface PageLayoutProps {
  header?: React.ReactNode;
  leftSection?: React.ReactNode;
  children?: React.ReactNode;
  content?: React.ReactNode;
  page?: boolean;
  fullWidth?: boolean;
  overflowHidden?: boolean;
}

export const PageLayout = ({
  header,
  leftSection,
  page,
  children,
  fullWidth = false,
  overflowHidden,
}: PageLayoutProps) => {
  return (
    <div className="font-inter flex flex-col items-center w-full h-full overflow-hidden flex-1">
      <div className="flex justify-center w-ds-page static">{header}</div>
      <div
        className={classNames('w-full flex h-full justify-center', {
          'overflow-y-scroll overflow-x-hidden': !overflowHidden,
          'overflow-hidden': overflowHidden,
          'bg-ds-natural-50': page,
        })}
      >
        <div
          className={classNames('flex justify-center ', {
            'w-ds-page': !fullWidth,
            'w-full': fullWidth,
          })}
        >
          <div className="w-full flex justify-between flex-center">
            {leftSection && (
              <div
                className={classNames(
                  'flex-col flex items-start w-ds-info-section'
                )}
              >
                {leftSection}
              </div>
            )}
            <div
              className={classNames({
                'w-full': !leftSection,
                'mt-5': header && !leftSection,
                'w-ds-content-section mt-8': leftSection,
              })}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
